"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _Icons = require("./Icons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function FileListItem(_ref) {
  var path = _ref.path,
    access = _ref.access,
    _ref$temporal = _ref.temporal,
    temporal = _ref$temporal === void 0 ? false : _ref$temporal,
    _ref$seconds = _ref.seconds,
    seconds = _ref$seconds === void 0 ? 600 : _ref$seconds,
    selected = _ref.selected,
    onSelected = _ref.onSelected;
  var extension = (0, _react.useMemo)(function () {
    var i = path.lastIndexOf('.');
    return path.substring(i + 1).toUpperCase();
  }, [path]);
  var name = (0, _react.useMemo)(function () {
    var i = path.lastIndexOf('/');
    var prefixedName = path.substring(i + 1);
    var j = prefixedName.indexOf('_');
    return prefixedName.substring(j + 1);
  }, [path]);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  (0, _react.useEffect)(function () {
    if (onSelected) return;
    if (!path) return;
    (0, _api.secure)({
      http_method: 'GET',
      key: path,
      temporal: temporal,
      seconds: seconds
    }, {
      access: access
    }).then(function (response) {
      setUrl(response.url);
    })["catch"](function (error) {
      console.error(error);
    });
  }, [access, path, onSelected, temporal, seconds]);
  return /*#__PURE__*/_react["default"].createElement(_material.ListItem, {
    dense: true,
    disableGutters: true,
    secondaryAction: onSelected ? (/*#__PURE__*/_react["default"].createElement(_material.IconButton, {
      size: "small",
      color: "primary",
      onClick: function onClick() {
        return onSelected(path);
      }
    }, selected === path ? (/*#__PURE__*/_react["default"].createElement(_Icons.RadioCheckedIcon, null)) : (/*#__PURE__*/_react["default"].createElement(_Icons.RadioUncheckedIcon, null)))) : (/*#__PURE__*/_react["default"].createElement(_material.IconButton, {
      size: "small",
      color: "primary",
      disabled: !url,
      component: "a",
      href: url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react["default"].createElement(_Icons.DownloadIcon, null)))
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemAvatar, null, /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    sx: function sx(theme) {
      return {
        bgcolor: theme.palette.primary.light
      };
    }
  }, /*#__PURE__*/_react["default"].createElement("sub", null, /*#__PURE__*/_react["default"].createElement("small", null, extension)))), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: name
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FileListItem);